export default __webpack_public_path__ + "McDonalds_all_yellow.1da8935.png";